/*
  ============================================================
  fato.js — Microinteracoes do tema Fato Paisagismo
  ============================================================

  O QUE FAZ:
  1. Revelacao suave (fade-up) de elementos [data-fato-reveal] quando
     entram na viewport, via IntersectionObserver.
  2. Carrosseis horizontais [data-fato-carousel]: botoes prev/next que
     rolam o track e ficam desabilitados nas extremidades.
  3. Filtro de categorias [data-fato-filter]: alterna quais grupos de
     produtos ja renderizados pelo Liquid ficam visiveis. Nao busca nada
     no servidor e nao inventa produto — so mostra/esconde grupos reais.
  4. Header: adiciona .is-stuck ao rolar e publica --fato-header-h com a
     altura real do cabecalho (que e fixed) para o CSS compensar.

  OBSERVACOES:
  - Sem dependencias externas. Roda com defer.
  - Respeita prefers-reduced-motion (a revelacao vira imediata).
  - initFato() e reexecutado nos eventos do Theme Editor
    (shopify:section:load), para o preview continuar funcionando.
*/
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Revelacao ao rolar ------------------------------------------------ */
  function initReveal(scope) {
    var items = (scope || document).querySelectorAll('[data-fato-reveal]:not(.fato-reveal-ready)');
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('fato-reveal-ready', 'is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = parseInt(el.getAttribute('data-fato-reveal-delay') || '0', 10);
          setTimeout(function () {
            el.classList.add('is-visible');
          }, delay);
          obs.unobserve(el);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    items.forEach(function (el) {
      el.classList.add('fato-reveal-ready');
      observer.observe(el);
    });
  }

  /* 2. Carrossel --------------------------------------------------------- */
  function initCarousels(scope) {
    var carousels = (scope || document).querySelectorAll('[data-fato-carousel]:not(.fato-carousel-ready)');

    carousels.forEach(function (carousel) {
      carousel.classList.add('fato-carousel-ready');

      var track = carousel.querySelector('[data-fato-carousel-track]');
      if (!track) return;

      var prev = carousel.querySelector('[data-fato-carousel-prev]');
      var next = carousel.querySelector('[data-fato-carousel-next]');

      function step() {
        var first = track.querySelector('li');
        if (!first) return track.clientWidth * 0.8;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || '20') || 20;
        return first.getBoundingClientRect().width + gap;
      }

      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft >= max;
        if (prev) prev.disabled = atStart;
        if (next) next.disabled = atEnd || max <= 0;
        carousel.classList.toggle('is-scrollable', max > 0);
      }

      function scrollBy(direction) {
        track.scrollBy({
          left: step() * direction,
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      }

      if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
      if (next) next.addEventListener('click', function () { scrollBy(1); });

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(sync);
      }, { passive: true });

      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* 3. Filtro de categorias --------------------------------------------- */
  function initFilters(scope) {
    var groups = (scope || document).querySelectorAll('[data-fato-filter]:not(.fato-filter-ready)');

    groups.forEach(function (root) {
      root.classList.add('fato-filter-ready');

      var buttons = root.querySelectorAll('[data-fato-filter-button]');
      var panels = root.querySelectorAll('[data-fato-filter-panel]');
      if (!buttons.length || !panels.length) return;

      function activate(value) {
        buttons.forEach(function (button) {
          var isActive = button.getAttribute('data-fato-filter-button') === value;
          button.setAttribute('aria-selected', String(isActive));
          button.classList.toggle('is-active', isActive);
        });
        panels.forEach(function (panel) {
          var isActive = panel.getAttribute('data-fato-filter-panel') === value;
          panel.hidden = !isActive;
          if (isActive) {
            var track = panel.querySelector('[data-fato-carousel-track]');
            if (track) track.scrollLeft = 0;
          }
        });
        window.dispatchEvent(new Event('resize'));
      }

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          activate(button.getAttribute('data-fato-filter-button'));
        });
      });

      var initial = root.querySelector('[data-fato-filter-button][aria-selected="true"]') || buttons[0];
      activate(initial.getAttribute('data-fato-filter-button'));
    });
  }

  /* 4. Header ao rolar --------------------------------------------------- */
  function initHeader() {
    var header = document.querySelector('[data-fato-header]');
    if (!header || header.dataset.fatoHeaderReady === 'true') return;
    header.dataset.fatoHeaderReady = 'true';

    function update() {
      header.classList.toggle('is-stuck', window.scrollY > 12);
    }

    // Publica a altura do header para o CSS compensar o espaço nas
    // páginas internas (o header é fixed e sai do fluxo).
    function measure() {
      document.documentElement.style.setProperty('--fato-header-h', header.offsetHeight + 'px');
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    update();
    measure();
  }

  /* ----------------------------------------------------------
     Balao do botao de WhatsApp
     Surge depois de whatsapp_float_delay segundos e some depois de
     whatsapp_float_duration. Duration 0 deixa fixo. O hover revela
     de novo a qualquer momento, isso e' so CSS.
     ---------------------------------------------------------- */

  function initWhatsapp() {
    var btn = document.querySelector('.fato-whatsapp');
    if (!btn || btn.dataset.labelReady === 'true') return;

    var label = btn.querySelector('.fato-whatsapp__label');
    if (!label) return;

    btn.dataset.labelReady = 'true';

    var delay = parseFloat(btn.dataset.labelDelay);
    var duration = parseFloat(btn.dataset.labelDuration);
    if (isNaN(delay) || delay < 0) delay = 4;
    if (isNaN(duration) || duration < 0) duration = 8;

    window.setTimeout(function () {
      label.classList.add('is-visible');
      if (duration > 0) {
        window.setTimeout(function () {
          label.classList.remove('is-visible');
        }, duration * 1000);
      }
    }, delay * 1000);
  }

  function initFato(scope) {
    initReveal(scope);
    initCarousels(scope);
    initFilters(scope);
    initHeader();
    initWhatsapp();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initFato(); });
  } else {
    initFato();
  }

  // Theme Editor: reinicializa a section recem-carregada
  document.addEventListener('shopify:section:load', function (event) {
    initFato(event.target);
  });

  window.initFato = initFato;
})();
